var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.156 22.317C8.54899 22.3162 7.96708 22.0747 7.53796 21.6453C7.10883 21.216 6.86753 20.634 6.867 20.027H11.444C11.4435 20.6338 11.2023 21.2157 10.7734 21.645C10.3445 22.0743 9.76284 22.3159 9.156 22.317ZM18.312 18.883H0V17.739L2.289 15.45V9.727C2.25438 8.07787 2.72283 6.45731 3.632 5.081C4.53082 3.7711 5.89005 2.84781 7.439 2.495V1.717C7.439 1.26162 7.6199 0.824898 7.9419 0.502898C8.2639 0.180898 8.70062 0 9.156 0C9.61138 0 10.0481 0.180898 10.3701 0.502898C10.6921 0.824898 10.873 1.26162 10.873 1.717V2.495C12.4198 2.85149 13.7761 3.7763 14.673 5.086C15.5838 6.46029 16.0541 8.0796 16.021 9.728V15.45L18.31 17.739V18.882L18.312 18.883Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMNotify);
export default __webpack_public_path__ + "static/media/m-notify.cb02efefa5c435f2236d685c67a95fe0.svg";
export { ForwardRef as ReactComponent };